module.exports = __webpack_public_path__ + "assets/User-solid.78083c93.svg";